import { render, staticRenderFns } from "./AlertasVigilantiPantalla.vue?vue&type=template&id=1e967ba8&"
import script from "./AlertasVigilantiPantalla.vue?vue&type=script&lang=ts&"
export * from "./AlertasVigilantiPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1e967ba8', component.options)
    } else {
      api.reload('1e967ba8', component.options)
    }
    module.hot.accept("./AlertasVigilantiPantalla.vue?vue&type=template&id=1e967ba8&", function () {
      api.rerender('1e967ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Alertas/AlertasVigilantiPantalla.vue"
export default component.exports